import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from "react";
import { customFieldIconMap } from "~/constants/customFieldIconMap";
import { useToggleViewVisibilityMenuOption } from "./hooks/useToggleViewVisibilityMenuOption";
import { useToggleViewVisibilityMenuOptions } from "./hooks/useToggleViewVisibilityMenuOptions";
import { ViewVisibilitySection } from "./ViewVisibilitySection/ViewVisibilitySection";
import { ViewVisibilityToggle } from "./ViewVisibilitySection/ViewVisibilityToggle";
export const CustomFieldsVisbilityOptions = /*#__PURE__*/ memo((param)=>{
    let { options, customFields } = param;
    const { toggleViewVisibilityMenuOption } = useToggleViewVisibilityMenuOption();
    const { toggleViewVisibilityMenuOptions } = useToggleViewVisibilityMenuOptions();
    const initialShowOptions = options.some((param)=>{
        let { isVisible } = param;
        return isVisible;
    });
    return /*#__PURE__*/ _jsx(ViewVisibilitySection, {
        initialShowOptions: initialShowOptions,
        id: "customFields",
        label: "Custom fields",
        onToggleShowingOptions: (showing)=>{
            toggleViewVisibilityMenuOptions(options, showing);
        },
        toggles: options.map((option)=>{
            const customField = customFields.find((cf)=>cf.id === option.customFieldId);
            const customFieldTypeName = customField === null || customField === void 0 ? void 0 : customField.type.title;
            const Icon = customFieldTypeName ? customFieldIconMap[customFieldTypeName] : null;
            return /*#__PURE__*/ _jsx(ViewVisibilityToggle, {
                onClick: ()=>toggleViewVisibilityMenuOption(option),
                option: option,
                prefix: !!Icon && /*#__PURE__*/ _jsx(Icon, {
                    width: 16
                })
            }, option.fieldName);
        })
    });
});
CustomFieldsVisbilityOptions.displayName = "CustomFieldsVisbilityOptions";
